//const BASE_URL = "https://stage.propagile.com/api/v1";
const BASE_URL = "https://api.propagile.com/api/v1";
const CLIENT_TEAM_URL = "https://www.propagile.com/building-construction-teams";
const CLIENT_PROPAGILE_URL = "https://testdev.propagile.com"
//const CLIENT_PROPAGILE_URL = "http://localhost:3000";
//const BASE_URL = "http://localhost:1337/api/v1";
//const CLIENT_TEAM_URL = "http://localhost:3000";
export { BASE_URL, CLIENT_TEAM_URL, CLIENT_PROPAGILE_URL };